import {Component, computed, input, output} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {ExternalLinkIcon, LinkIcon, LucideAngularModule, SquarePenIcon} from 'lucide-angular';
import {VenuePipe} from '@domain/venue/pipe/venue.pipe';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {ActivityUtil} from '@domain/activity/activity.util';

@Component({
  selector: 'app-activity-links',
  providers: [
    VenuePipe
  ],
  imports: [
    TranslocoDirective,
    LucideAngularModule
  ],
  templateUrl: './activity-links.component.html',
  styleUrl: './activity-links.component.scss'
})
export class ActivityLinksComponent {

  public readonly activity = input.required<ActivityDTO | null>();
  public readonly showAlways = input.required<boolean>();
  public readonly canEdit = input(false);

  public readonly edit = output<void>();

  public readonly icons = {
    links: LinkIcon,
    externalLink: ExternalLinkIcon,
    edit: SquarePenIcon
  };

  public readonly hasActivityLinks = computed(() => ActivityUtil.hasLinks(this.activity()));

  public readonly socialLabels = {
    web: 'web',
    fb: 'facebook',
    ig: 'instagram'
  }

  public editClick(): void {
    this.edit.emit();
  }

}
